import React, { useState, useEffect, useRef } from "react";
import ShareTable from "../../../shares/tables/ShareTable";
import Search from "../../../shares/search/Search";
import {
  AccountCircleTwoTone,
  GroupsOutlined,
  UploadFileOutlined,
  AddRounded,
} from "@mui/icons-material";
import { Modal } from "@mui/material";
import useFetch from "../../../../hooks/useFetch";
import { Link, useSearchParams } from "react-router-dom";
import AddVideos from "./modals/AddVideos";
import { toast } from "react-toastify";
import { PageHeader } from "../../../shares/dashboard/DashboardWidgets";

const Students = () => {
  const [newModal, setNewModal] = useState(false);
  const [questions, setQuestion] = useState();
  const [imported, setImported] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [call, setCall] = useState({
    file: null,
  });

  const handleClose = () => {
    setNewModal(false);
  };

  const getQuestion = useFetch({
    method: "GET",
    url: `management/users/?page=${searchParams.get("page") ?? 1}&search=${
      searchParams.get("search") ?? ""
    }`,
    noHeader: false,
    trigger: true,
    setter: setQuestion,
  });

  const importReq = useFetch({
    method: "POST",
    url: `management/upload-excel/`,
    noHeader: false,
    trigger: false,
    data: call,
  });

  const columns = [
    { id: "username", label: "کدملی" },
    { id: "first_name", label: "نام" },
    { id: "last_name", label: "نام خانوادگی" },
    {
      id: "student_school",
      label: "مدرسه",
      render: (row) => row.studentuser?.student_school,
    },
    {
      id: "groups",
      label: "گروه",
      render: (row) =>
        row.groups?.[0]?.name ? (
          <span className="rounded-pill bg-surface-sunken px-md py-2xs text-xs text-ink-muted">
            {row.groups[0].name}
          </span>
        ) : (
          <span className="text-ink-subtle">—</span>
        ),
    },
    {
      id: "profile",
      label: "پروفایل",
      render: (row) => (
        <Link
          to={`${row.id}`}
          aria-label="مشاهده پروفایل دانش‌آموز"
          className="inline-flex h-[3.2rem] w-[3.2rem] items-center justify-center rounded-soft text-ink-muted transition-colors duration-150 hover:bg-primary-soft hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          <AccountCircleTwoTone sx={{ fontSize: "2rem" }} />
        </Link>
      ),
    },
  ];

  const questionRef = useRef(null);

  const handleClickQuestion = () => {
    questionRef.current.click();
  };

  useEffect(() => {
    if (imported) {
      const formData = new FormData();

      formData.append("file", imported);

      setCall(formData);

      importReq.reFetch();
    }
  }, [imported]);

  useEffect(() => {
    if (importReq.status && importReq.status === 201) {
      toast.success("کاربران با موفقیت بارگزاری شدند");
      setImported(null);
      setCall({
        file: null,
      });
    } else if (importReq.status && importReq.status !== 201) {
      toast.error("خطا در بارگزاری کاربران");
      setImported(null);
      setCall({
        file: null,
      });
    }
  }, [importReq.status]);

  return (
    <div className="flex flex-col gap-xl pb-4xl">
      <PageHeader
        title="دانش‌آموزان"
        description="فهرست دانش‌آموزان، بارگذاری گروهی و مدیریت پروفایل"
        icon={GroupsOutlined}
      >
        <div className="flex shrink-0 flex-wrap items-center gap-sm">
          <button
            type="button"
            onClick={handleClickQuestion}
            disabled={importReq.loading}
            className="inline-flex items-center gap-2xs rounded-soft border border-rule bg-surface px-lg py-sm text-base text-ink-muted transition-colors duration-150 hover:bg-surface-sunken hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-60 motion-reduce:transition-none"
          >
            <UploadFileOutlined sx={{ fontSize: "1.8rem" }} />
            {importReq.loading ? "در حال بارگذاری…" : "بارگذاری اکسل"}
          </button>
          <input
            type="file"
            ref={questionRef}
            onChange={(e) => setImported(e.target.files[0])}
            required
            style={{ display: "none" }}
          />
          <button
            type="button"
            onClick={() => setNewModal(true)}
            className="inline-flex items-center gap-2xs rounded-soft bg-primary px-lg py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none"
          >
            <AddRounded sx={{ fontSize: "1.8rem" }} />
            افزودن دانش‌آموز
          </button>
        </div>
      </PageHeader>

      <div className="flex flex-col gap-lg">
        <Search getFiltered={getQuestion} />

        <ShareTable
          data={questions?.results ?? []}
          columns={columns}
          getPage={getQuestion}
          totalCount={questions?.count}
          page={Number(searchParams.get("page")) || 1}
          setPage={setSearchParams}
        />
      </div>

      <Modal
        open={newModal}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AddVideos close={handleClose} get={getQuestion} />
      </Modal>
    </div>
  );
};

export default Students;
